import { get } from "helpers/api_helper";
import { ADMIN_EMAIL_VALIDATION } from 'helpers/url_helper';

const asyncValidate = (values = {}) => {
    if (!values['email_address']) {
        return Promise.resolve();
    }

    return get(ADMIN_EMAIL_VALIDATION, { params: { mail: values['email_address'] } })
        .then(({ exists }) => {
            if (exists) throw { email_address: 'The email has already been added to contacts' };
        });
};

export default (asyncValidate);